import request from '@/utils/request_hk'

// 创建支付订单
export function createOrder_hk(data) {
  return request({
    url: `/api/v1/live/create-order`,
    method: 'POST',
    data
  })
}

// 查询订单支付状态
export function getOrderStatus_hk(data) {
  return request({
    url: `/api/v1/live/query-order-status`,
    method: 'POST',
    data
  })
}

// 查询卡号对应appid
export function getCardAppid_hk(data) {
  return request({
    url: `/api/v1/live/q-card-appid`,
    method: 'POST',
    data
  })
}


